import { format } from "date-fns";
import h from "../core/createElement";
import { byteMetter } from "../utils";
import Btn from "./btn";
import popupAlerts from "../core/popupAlerts";
import file_service from "../service/file_service";


export default function FileCard({ data: { name, size, updated_at, type, id, can_be_deleted }, delete_file, update_file }) {

    let input_file;

    const _size = byteMetter(size), _types = { sub_report: "Sub Relatório", main_report: "Principal" };

    const
        do_upt_treatment = (evt) => {
            const file = evt.target.files[0];
            evt.target.value = "";

            update_file && update_file({ name, size, updated_at, type, id }, file);
        },
        download_file = async () => {
            const progress_bar = popupAlerts.progress('A fazer o download...');
            try {
                const progress_callback = (evt) => {
                    progress_bar.progress((evt.loaded / evt.total) * 100)
                };

                const { data } = await file_service.download_file(progress_callback, id);

                progress_bar.dismiss();

                const url = window.URL.createObjectURL(new Blob([data]));

                const a = h('a', { href: url, style: "display: none;", download: name });

                document.body.appendChild(a);

                a.click();
                a.remove();
            } catch (e) {
                progress_bar.dismiss();
            }
        };

    return (
        <article class="card">
            {input_file = <input type="file" class="d-none" accept=".jrxml" name={name} onChange={do_upt_treatment} />}
            <div class="top">
                <span class="title">{name}</span>
                <span>{_size.total.toFixed(2) + _size.unity}</span>
            </div>

            <div class="bottom">

                <div class="flex-1">
                    <span class="blue file-card-mod"><strong>MOD: </strong>{format(updated_at, "dd/MM/yyyy HH:mm")}</span>
                    <span class="orange">{_types[type]}</span>
                </div>

                <div class="flex-1 justify-end file-card-btns">

                    {can_be_deleted ? <Btn icon="assets/image/trash.svg" color="red" onClick={() => delete_file({ name, size, updated_at, type, id })} /> : ""}

                    <Btn icon="assets/image/swap.svg" color="dark-gray" onClick={() => input_file.click()} />

                    <Btn icon="assets/image/download-simple.svg" color="blue" onClick={download_file} />
                </div>
            </div>
        </article>
    );
};